import { Icon } from '@openeducation/oe-rn-components';
import React, { useMemo } from 'react';
import { StyleSheet, TouchableOpacity } from 'react-native';

import { useColors } from '../../../../hooks';
import { useActivityContext } from '../../../../hooks/use-activity.context';

interface LessonPlayerArrowButtonProps {
  onPress: () => void;
  direction: 'right' | 'left';
}

export const LessonPlayerArrowButton: React.FC<
  LessonPlayerArrowButtonProps
> = ({ onPress, direction }) => {
  const colors = useColors();
  const {
    currentIndex,
    totalActivitiesCompleted,
    totalSlides,
    activityVisibility,
  } = useActivityContext();

  const isDisabled = useMemo(() => {
    if (!activityVisibility) {
      return false;
    }

    const isCompleted = currentIndex >= totalSlides;

    if (direction === 'left') {
      return isCompleted || currentIndex <= 0;
    }

    return isCompleted || currentIndex >= totalActivitiesCompleted;
  }, [
    currentIndex,
    totalActivitiesCompleted,
    totalSlides,
    activityVisibility,
    direction,
  ]);

  return (
    <TouchableOpacity
      accessibilityRole="button"
      disabled={isDisabled}
      style={[styles.button, direction === 'right' && styles.rightButton]}
      hitSlop={{ top: 20, right: 8, bottom: 20, left: 8 }}
      onPress={onPress}
    >
      <Icon
        type="solid"
        name={`arrow-${direction}`}
        size={18}
        color={isDisabled ? colors.grayLight : colors.gray}
      />
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  button: {
    width: 38,
  },
  rightButton: {
    alignItems: 'flex-end',
    width: 32,
  },
});
